import React, { Component } from 'react';
import __ from 'lodash';
import {Row, Col, Form} from 'react-bootstrap';

class SoalEssay extends Component {
    constructor(props) {
        super(props);
        this.state = {  
            soal: this.props.soal,
        }
    }

    componentDidMount(){
        (function()
        {
          if( window.localStorage )
          {
            if( !localStorage.getItem('firstLoad') )
            {
              localStorage['firstLoad'] = true;
              window.location.reload();
            }  
            else
              localStorage.removeItem('firstLoad');
          }
        })();
    }
   
    handleChangeKunci = (e) => {   
        this.props.handleChange(e.target.value)
    }

    render() {         
        return (  
            <div className="content">
            <Col sm={12} style={{ marginBottom:'50px'}}>                                 
                <Form.Group controlId="pertanyaan">
                    <Form.Label><h6>Pertanyaan: </h6></Form.Label>                        
                    <textarea className="tinymce_textarea" id="pertanyaan" value={this.state.soal.pertanyaan||''} required></textarea>    
                </Form.Group>        

                <Form.Group as={Row} controlId="kunci">
                    <Form.Label column sm="2"><h6>Kunci Jawaban: </h6></Form.Label>                        
                    <Col sm="4"> 
                    <input className="form-control" type="text" name="kunci" defaultValue={this.state.soal.kunciJawaban} onChange={this.handleChangeKunci.bind(this)} />
                    </Col>
                </Form.Group>

                <Form.Group controlId="pembahasan">
                    <Form.Label><h6>Pembahasan: </h6></Form.Label>                        
                    <textarea className="tinymce_textarea" id="pembahasan" value={this.state.soal.isianJawaban||''} required></textarea>    
                </Form.Group>

            </Col> 
            </div>
        );
    }
}
 
export default SoalEssay;